import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.commodityDetailedPage || initialState;

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectCommodityWiseDetails = createSelector(
  [selectDomain],
  (state) => state.commodityWiseDetails
);